export default __webpack_public_path__ + "a924785.png";